import axios from '@fs/zion-axios'
import { useUser } from '@fs/zion-user'
import { useParams } from '@fs/zion-router'
import { useKeep } from '../useKeep'

import { KEEP_PROCESS_TYPE } from '../../helpers'

const { DOWNLOAD } = KEEP_PROCESS_TYPE

const useUploadToMemoriesGallery = () => {
  const { personId } = useUser()
  const { downloadRef, handleProcess, setProcessing } = useKeep()
  const { design } = useParams()

  const processImageFile = async () => {
    return handleProcess({
      downloadType: 'jpeg',
      process: DOWNLOAD,
      focusBackRef: downloadRef,
      fromMemoryBooks: true,
      designName: design,
    })
  }

  const uploadTreeDesignToMemoriesGallery = async ({
    history,
    fromMemoryBooks,
    errorUploadingToMemoriesOverlay,
    memoryBooksPageNumber,
  }) => {
    const redirectToMemoryBooks = (memoryId) => {
      setProcessing(null)
      history.pushWhenLocal(`${fromMemoryBooks}?uploadedDesignId=${memoryId}&pageNumber=${memoryBooksPageNumber}`)
    }

    try {
      const imageFile = await processImageFile()
      const name = imageFile?.name || 'tree-design.jpeg'

      if (!imageFile || !personId || !name) {
        console.error('Cannot upload photo with undefined data', { imageFile, personId, name })
        return
      }

      const { data } = await axios.post(
        `/service/memories/manager/artifacts/files?filename=${encodeURIComponent(name)}&title=${encodeURIComponent(name)}&isPrivate=true`,
        imageFile,
        { headers: { 'Content-Type': imageFile.type } }
      )

      redirectToMemoryBooks(data?.artifact?.id)
    } catch (error) {
      if (error.response?.status === 409) {
        // there is a duplicate image, grab the memory ID from the header
        // looks like `* (0123456789)`
        const memoryIdString = error.response.headers.warning.split('(')[1]
        const memoryId = memoryIdString.substring(0, memoryIdString.length - 1)
        redirectToMemoryBooks(memoryId)
      } else {
        setProcessing(null)
        errorUploadingToMemoriesOverlay.open()
      }
    }
  }

  return { uploadTreeDesignToMemoriesGallery }
}

export default useUploadToMemoriesGallery
